import { render } from "./Paginas.vue?vue&type=template&id=35d0bde6"
import script from "./Paginas.vue?vue&type=script&lang=js"
export * from "./Paginas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__